import { SVGProps } from 'react';

const UserSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.3 15H7a4 4 0 0 0-4 4v2m18 0-1.9-1.9M14 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0m6 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default UserSearch;
